import { render, staticRenderFns } from "./index.vue?vue&type=template&id=359dfe84&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359dfe84')) {
      api.createRecord('359dfe84', component.options)
    } else {
      api.reload('359dfe84', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=359dfe84&", function () {
      api.rerender('359dfe84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/return/index.vue"
export default component.exports